




















import Vue from 'vue';

import Sidebar from '@/components/layout/Sidebar.vue';
import Navigation from '@/components/layout/Navigation.vue';
import Welcome from '@/components/Home/Welcome.vue';
import About from '@/components/Home/About.vue';
import Services from '@/components/Home/Services.vue';
import Testimonials from '@/components/Home/Testimonials.vue';
import Gallery from '@/components/Home/Gallery.vue';
import Contact from '@/components/Home/Contact.vue';
import SiteFooter from '@/components/Home/Footer.vue';


export default Vue.extend({
  name: 'home',
  components: {
    Sidebar,
    Navigation,
    Welcome,
    About,
    Services,
    Testimonials,
    Gallery,
    Contact,
    SiteFooter,
  },
});
